import { DashMessage } from "./DashMessage"
import { useDashboardDomainContext } from "../../../DashboardDomainProvider";

export const UnpublishedMessage = () => {

    const { switchMode } = useDashboardDomainContext();

    return (
        <DashMessage
            icon={"protractor"}
            title={"Dashboard in Progress"}
            description={"Continue editing the unpublished dashboard."}
            buttonText={"Continue Editing"}
            onClick={() => switchMode("design")}
        />
    )
}